import type { RouteRecordRaw } from 'vue-router'

export const posRoutes: RouteRecordRaw[] = [
  {
    path: '/pos',
    children: [
      {
        path: 'areas',
        name: 'Areas',
        component: () => import('@/modules/pos/views/AreasListScreen.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'tables/:areaId',
        name: 'Tables',
        component: () => import('@/modules/pos/views/TablesListScreen.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'table-actions',
        name: 'TablesActions',
        component: () => import('@/modules/pos/views/TablesActionsScreen.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'order/:areaId/:tableId',
        name: 'CreateOrder',
        component: () => import('@/modules/pos/views/CreateOrderScreen.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'success',
        name: 'Success',
        component: () => import('@/modules/pos/views/SuccessScreen.vue'),
        meta: { requiresAuth: true },
      },
    ],
  },
]